<template>
    <div>
        <footer>
            <div class="bottom-content">
                <div class="container ">
                    <div class="row">
                        <div class="col-lg-10 col-md-10 mx-auto">
                            <ul class="list-inline text-center">
                                <li class="list-inline-item">
                                    <a class="icon_link" href="https://unatlib.ru" target="_blank">
                                        <b-icon icon="house-door-fill" :class="[white ? 'text-white' : 'home-muted']"
                                            class="h1"></b-icon>
                                    </a>
                                </li>
                                <li class="list-inline-item">
                                    <a class="icon_link" href="https://vk.com/unatlib" target="_blank">
                                        <img v-if="white" src="~@/assets/vk_w.svg" height="64px" style="margin-top:-30px;">
                                        <img v-else src="~@/assets/vk.svg" height="64px" style="margin-top:-30px;">
                                    </a>
                                </li>
                                <!-- <li class="list-inline-item">
                                    <a class="icon_link" href="https://vk.com/unatlib" target="_blank">
                                        <span class="fa-stack fa-lg">
                                            <i class="fa fa-circle fa-stack-2x"></i>
                                            <i class="fa fa-vk fa-stack-1x fa-inverse"></i>
                                        </span>
                                    </a>
                                </li>
                                <li class="list-inline-item">
                                    <a class="icon_link" href="https://www.youtube.com/user/unatlib" target="_blank">
                                        <b-icon icon="youtube" class="rounded-circle p-2 btn btn-primary" font-scale="2"
                                            variant="light"></b-icon>
                                    </a>
                                </li> -->
                            </ul>
                            <p :class="'copyright ' + [white ? 'text-white' : 'text-muted']">&copy; {{ year }},
                                Национальная библиотека Удмуртской Республики
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
export default {
    data() {
        return {
            year: null,
            white: false
        }
    },
    mounted() {
        if (this.$route.path === '/' ||
            this.$route.path === '/account/registration' ||
            this.$route.path === '/account/recovery' ||
            this.$route.name === 'accountSave' ||
            this.$route.path === "/404") {
            this.white = true;
        }
        this.year = new Date().getFullYear();
    }
}
</script>

<style>
footer {
    position: relative;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 150px;
}

.bottom-content {
    position: absolute;
    bottom: 0;
    width: 100%;
}

.home-muted {
    color: #6a0583;
}
</style>